export interface ProjectOption {
  label: string;
  value: string;
  organizationId: string;
}

export interface SelectOption<T = string> {
  label: string;
  value: T;
}

export const ALL_PROJECTS_VALUE = 'ALL_PROJECTS' as const;
export const ALL_PROJECTS_OPTION: SelectOption = {
  label: 'All Projects',
  value: ALL_PROJECTS_VALUE,
};